import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/");
      return;
    }
    api
      .post("/auth/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.user?.onboarding ? "/profil" : "/onboarding", { state: { user: data.user } });
      })
      .catch(() => navigate("/auth"));
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" data-testid="auth-callback-spinner" />
    </div>
  );
};
